<div [ngStyle]="progressBarStyle"  #progressBar id="progressBar"></div>
